import { AxiosResponse } from 'axios'
import { useContext } from '@nuxtjs/composition-api'
import { CARDS_LK } from '../../../config/bitrix-endpoints'
import { CardsLkResponse } from '../../../contracts/CardsLk'
import { BITRIX_API } from '../instance'

export async function getCardsLk(
  ctx: ReturnType<useContext> | undefined = undefined
): Promise<AxiosResponse<CardsLkResponse>> {
  return await BITRIX_API(ctx).get(CARDS_LK, { params: { code: 'ru' } })
}
